// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18m9ewfl{overflow-y:visible}\n._1reoewfl{overflow-x:visible}", ""]);
// Exports
module.exports = exports;
